import * as Yup from 'yup';

export const initialValues = {
    smartResponseFormat: [{ value: '' }],
};

export const validationSchema = Yup.object().shape({
    smartResponseFormat: Yup.array().of(
        Yup.object().shape({
            value: Yup.string().required('Requerido'),
        })
    ),
});
